import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { DBCustomerSignal } from "@/lib/db-types";

export interface CustomerSignalWithRefs extends DBCustomerSignal {
  agent: { name: string } | null;
  claimer: { full_name: string } | null;
}

const SELECT_WITH_REFS =
  "*, agent:signal_agents!customer_signals_agent_id_fkey(name), claimer:users!customer_signals_claimed_by_fkey(full_name)";

/** Kundekortets signalfeed: de siste signalene på kunden, uansett status. Bundet av customer_id. */
export function useCustomerSignals(
  customerId: string | undefined,
  options: { limit?: number; enabled?: boolean } = {},
) {
  const limit = options.limit ?? 20;
  return useQuery({
    queryKey: ["customer-signals", customerId, { limit }],
    queryFn: async (): Promise<CustomerSignalWithRefs[]> => {
      const { data, error } = await supabase
        .from("customer_signals")
        .select(SELECT_WITH_REFS)
        .eq("customer_id", customerId!)
        .order("created_at", { ascending: false })
        .limit(limit);
      if (error) throw error;
      return (data ?? []) as unknown as CustomerSignalWithRefs[];
    },
    enabled: !!customerId && (options.enabled ?? true),
    staleTime: 60 * 1000,
  });
}
